import useTables from './useTables';

export default useTables;
